import BaseHistoryRecordModel from '../BaseHistoryRecordModel';
import { HistoryRecordDto } from '../../services/types';

export default class ObjectRoleAssignmentHistoryRecordModel extends BaseHistoryRecordModel {
    constructor(data: HistoryRecordDto) {
        super(data);
    }

    get assignmentObjectId() {
        const objectId = this.fields.find(field => field.name === 'UserId')?.value;
        return typeof objectId === 'string' ? objectId : undefined;
    }

    get objectLabel() {
        return 'Role Assignment';
    }
}
